// import CadencierService from '@/services/CadencierService'
import moment from 'moment'
import {
  AchatService,
} from '../services/AchatService'
import CommonUtils from '../utils/commonUtils'
import {
  NotilusService,
} from '../services/NotilusService'


export const state = {
  loading: false,
  pendingAchat: false,
  achats: [],
  achatsRanges : [], 
  billPref: false,
  fournisseurs: [],
  dateStart: moment().format('YYYY-MM-DD'),
  currentDate: moment().format('YYYY-MM-DD'),
  dateEnd: null,
}

export const mutations = {
  setAchatsLoading(currentState, loading) {
    currentState.achats.loading = loading
  },
  setBillPref(currentState, billPref) {
    currentState.achats.billPref = billPref
  },
  setAchatsRange(currentState, achats){ 
    currentState.achats.achatsRanges = achats.achats
  },
  setAchats(currentState, achats) {
    currentState.achats.achats = achats.achats
    currentState.achats.dateStart = achats.dateStart
    currentState.achats.dateEnd = achats.dateEnd
    currentState.achats.currentDate = achats.currentDate
  },
  setFournisseursAchats(currentState, fournisseurs) {
    currentState.achats.fournisseurs = fournisseurs
  },
}

export const getters = {
  formatedAchats: state => {
    if (state.achats.achats) {
      const achatsData = {
        factures: state.achats.achats,
        objectifJour: state.objectifs.objectifsDetail,
      }
      return CommonUtils.dictionnaryFromArray(AchatService.generateTableauAchats(achatsData,
        state.achats.currentDate, state.achats.fournisseurs, AchatService.getTypeAchats()))
    }
    return {}
  },
}

export const actions = {
  loadAchats({
    commit,
    rootState,
  }, params) {
    commit('setAchatsLoading', true)

    return AchatService.getAchats(rootState.authentication.userProfile.attributes
      .hublot_clientid[0], params.dateStart, params.dateEnd).then(achats => {
      commit('setAchatsLoading', false)
      commit('setAchats', {
        achats,
        dateStart: params.dateStart,
        dateEnd: params.dateEnd,
        currentDate: params.currentDate,
      })
    })
  },
  loadAchatsRange({
    commit,
    rootState,
  }, params) {
    return AchatService.getAchatsRange(rootState.authentication.userProfile.attributes
      .hublot_clientid[0], params.dateStart, params.dateEnd).then(achats => {
      commit('setAchatsRange', { achats })
    })
  },
  loadFournisseurs({
    commit,
    rootState,
  }) {
    return AchatService.getFournisseurs(rootState.authentication.userProfile.attributes
      .hublot_clientid[0]).then(fournisseurs => {
      commit('setFournisseursAchats', fournisseurs)
    })
  },
  loadBillPref({
    commit,
    rootState,
  }) {
    return NotilusService.getBillPreferences(rootState.authentication.userProfile.attributes
      .hublot_clientid[0]).then(billPref => {
      commit('setBillPref',
        CommonUtils.toBoolean(billPref[0].facturesPayees))
    })
  },
  addInvoice({
    /*eslint-disable */
    commit,
    rootState
    /* eslint-enable */
  }, params) {
    this.pendingAchat = true
    return Promise.all(params.map(achat => AchatService.insert(achat))).then(() => { this.pendingAchat = false })
  },
}
export default {
  state,
  actions,
  mutations,
  getters,
}
